export const formatUOSNumber = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  return String(value).padStart(2, '0');
};

export const ssrLabelToIndex = (label) =>
  Number(String(label ?? '').replace(/^ssr/i, '')) - 1;

